import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import type { SxProps, Theme } from '@mui/material/styles';
import { ReactNode } from 'react';

import { FULL_HEIGHT } from '@/core/constants/layout';

import { mainContentStyles as sx } from './MainContent.styles';

type Props = {
	children: ReactNode;
	fullHeight?: boolean;
	customSx?: SxProps<Theme>;
};

export const MainContent = ({
	children,
	customSx,
	fullHeight = false
}: Props) => {
	return (
		<Stack
			direction='column'
			role='main'
			component='main'
			alignItems='stretch'
			minHeight={FULL_HEIGHT}
			sx={sx.mainContentRoot}
		>
			<Container maxWidth='xl' disableGutters sx={sx.mainContentContainer}>
				{fullHeight ? (
					<Box height={FULL_HEIGHT} width={'100%'} sx={customSx}>
						{children}
					</Box>
				) : (
					<Box sx={customSx}>{children}</Box>
				)}
			</Container>
		</Stack>
	);
};
